import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EventIconsComponent } from '../event-icons/event-icons.component';
import { CommonModule } from '@angular/common';
import { MomentPipe } from 'src/app/shared/pipes/moment.pipe';

@Component({
  selector: 'app-calendar-week-view',
  templateUrl: './week-view-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, EventIconsComponent, MomentPipe],
})
export class WeekViewEventComponent {
  @Input('event') event;
}
